module.exports = __webpack_public_path__ + "img/PEC5000-aodo.2515c398.png";